import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
// import {BathTubType, LayoutType} from "../constants";
import {bathTubThumbnail} from "../../../bvComponent/core/assets";

import BathTubBody from "../subparts/bathTub/bathTubBody";
import BathTubFixture from "../subparts/bathTub/bathTubFixture";

export class Bathtub extends Part {
  static id = 'Bathtub';

  constructor() {
    super(true, false, PartMenuType.Complex);
    this.menuType = PartMenuType.Complex;
    this.partName = 'Bathtub';
    this.translateId = "visualizer.bathroom.bathtub";
    this.partThumbnail = bathTubThumbnail;
    this.bathTubBody = null;
    this.bathTubFixture = null;
    this.relatedItems = [];
  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Bathtub":
        relatedItemName = "bathTubBody";
        RelatedItemClass = BathTubBody;
        break;
      case "Bathtub Fixture":
        relatedItemName = "bathTubFixture";
        RelatedItemClass = BathTubFixture;
        break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        this.relatedItems.push(this[relatedItemName]);
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  changeLayout() {
  // changeLayout(layoutType) {
    // if (layoutType === LayoutType.Layout1 && this.bathTubBody) {
    //   // this.activeSubType_ = BathTubType.Custom60in;
    //   // this.bathTubType_ = BathTubType.Custom60in;
    //   if (!this.layout.parts.Shower.showerBody.disabled) { // disable bathtub if shower is active
    //     if (this.bathTubBody) {
    //       this.bathTubBody.disabled = true;
    //     }
    //   }
    // } else {
    //   if (this.bathTubBody) {
    //     this.bathTubBody.disabled = false;
    //   }
    // }
  }
}
